import { showCtConfirm } from "@conectate/components/ct-confirm.js";
import { PushID } from "@conectate/components/ct-helpers";
import dayjs from "dayjs";
import { getAuth } from "firebase/auth";

let pushid = new PushID();

export function getAPIv3URL() {
	// @ts-ignore window.apiURLv3 = "http://localhost:8082/v3";
	let apiURL = window.apiURLv3 || sessionStorage.apiURLv3 || localStorage.apiURLv3;
	if (apiURL) return apiURL;
	return process.env.SERVER_URLV3;
}

function toQueryString(obj: any) {
	var parts = [];
	for (var i in obj) {
		if (obj.hasOwnProperty(i) && obj[i] != undefined) {
			parts.push(encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]));
		}
	}
	return parts.join("&");
}
namespace xFetchv3 {
	export type xResponse<T, E> = [T, xError<E> | undefined, Response];

	export interface xError<E> {
		number: number;
		status: number;
		error_type: string;
		error_msg: string;
		data?: E;
	}

	export interface Pagination {
		token?: string;
		limit?: string;
		skip?: string;
	}
}

export function v3get<T = any, E = null>(url: string, params?: any, options?: { skipBaseURL?: boolean; forceToken?: boolean }): Promise<xFetchv3.xResponse<T, E>> {
	let parsedURL: URL;
	let idTokenPromise = getAuth().currentUser?.getIdToken(options?.forceToken) || Promise.resolve(`no-auth`);
	return new Promise(solve => {
		idTokenPromise
			.then(async idToken => {
				if (options?.skipBaseURL) parsedURL = new URL(url);
				else parsedURL = new URL(getAPIv3URL() + url);
				if (params) parsedURL.search = toQueryString(params);
				let p = await fetch(parsedURL.href, {
					headers: {
						Accept: "application/json, text/javascript, */*; q=0.01",
						Authorization: `bearer ${idToken}`,
						"Content-Type": "application/json",
						"Cache-Control": "no-cache",
						Pragma: "no-cache",
						"accept-language": navigator.language.substring(0, 2),
						"x-lang": navigator.language.substring(0, 2),
						"x-timezone": `${Number(dayjs().format("Z").split(":")[0])}`,
						"x-app-version": process.env.VERSION!,
						"x-app-build": process.env.BUILD!,
						"x-ats-id": window.app.localStorage.atsConfig?.id || "",
						"x-ats-name": window.app.localStorage.atsConfig?.title || ""
					},
					method: "GET",
					mode: "cors"
				});

				let jsonResult: any = {};
				try {
					jsonResult = await p.json();
				} catch {}
				if (p.status == 429) {
					showCtConfirm(
						"Parece que has abusado del servicio",
						"Se te ha denegado el servicio temporalmente por un uso inadecuado. Vuelve más tarde. Si vuelves a abusar del uso del servicio podemos inhabilitar tu cuenta de forma temporal o definitiva."
					);
				}
				let r: xFetchv3.xResponse<T, E> = [jsonResult, undefined, p];
				if (p.status >= 400) {
					r[1] = jsonResult;
					solve(r);
				} else {
					solve(r);
				}
			})
			.catch(function (error) {
				console.error(error);
				let msg = `${error}`;
				if (msg.includes("Failed to fetch")) msg = "No hay conexión a internet.v1";
				let r: xFetchv3.xResponse<T, E> = [
					null as any,
					{
						status: 0,
						number: 0,
						error_msg: msg,
						error_type: "InternetDisconnectedException"
					},
					null as any
				];
				solve(r);
			});
	});
}

export function v3http<T = any, E = null>(
	url: string,
	method: "POST" | "PUT" | "DELETE" | "PATCH" | "SEARCH",
	body?: any,
	options?: { skipBaseURL?: boolean; forceToken?: boolean }
): Promise<xFetchv3.xResponse<T, E>> {
	let parsedURL: URL;
	let idTokenPromise = getAuth().currentUser!.getIdToken(options?.forceToken);
	return new Promise((solve, err) => {
		if (typeof body == "object" && !(body instanceof FormData)) {
			body = JSON.stringify(body);
		}
		idTokenPromise
			.then(async idToken => {
				let Content_Type = body instanceof FormData ? "X-Content-Type" : "Content-Type";
				if (options?.skipBaseURL) parsedURL = new URL(url);
				else parsedURL = new URL(getAPIv3URL() + url);
				let p = await fetch(parsedURL.href, {
					headers: {
						Accept: "application/json, text/javascript, */*;",
						Authorization: `bearer ${idToken}`,
						[Content_Type]: "application/json",
						"Cache-Control": "no-cache",
						Pragma: "no-cache",
						"x-timezone": `${Number(dayjs().format("Z").split(":")[0])}`,
						"x-app-version": process.env.VERSION!,
						"x-app-build": process.env.BUILD!,
						"x-ats-id": window.app.localStorage.atsConfig?.id || "",
						"x-ats-name": window.app.localStorage.atsConfig?.title || ""
					},
					body: body,
					method: method,
					mode: "cors"
				});
				let jsonResult: any = {};
				try {
					jsonResult = await p.json();
				} catch {}
				if (p.status == 429) {
					showCtConfirm(
						"Parece que has abusado del servicio",
						"Se te ha denegado el servicio temporalmente por un uso inadecuado. Vuelve más tarde. Si vuelves a abusar del uso del servicio podemos inhabilitar tu cuenta de forma temporal o definitiva."
					);
				}

				// @ts-ignore
				let r: xFetch.xResponse<T> = [jsonResult, undefined, p];
				r.json = jsonResult;
				r.response = p;
				if (p.status >= 400) {
					r.error = jsonResult;
					r[1] = jsonResult;
					solve(r);
				} else {
					solve(r);
				}
			})
			.catch(function (error) {
				console.error(error);
				let msg = `${error}`;
				if (msg.includes("Failed to fetch")) msg = "No hay conexión a internet.v1";
				let r: xFetchv3.xResponse<T, E> = [
					null as any,
					{
						status: 0,
						number: 0,
						error_msg: msg,
						error_type: "InternetDisconnectedException"
					},
					null as any
				];
				solve(r);
			});
	});
}
